import React from 'react';
import Layout from '../components/Layout/Layout';
import { Link } from 'react-router-dom';

const Pagenotfound = () => {
  return (
    <Layout title={'الصفحة غير موجودة - النخبة ستور'}>
        <div className="pnf">
          <div className="premium-logo-circle" style={{marginBottom:'30px'}}>
            <img src="/images/logo1.jpeg" alt="النخبة ستور" width="90" height="90" />
          </div>
          <h1 className="pnf-title">404</h1>
          <h2 className="pnf-heading">عذراً! الصفحة غير موجودة</h2>
          <p style={{color:'var(--white-muted)', marginBottom:'20px'}}>الصفحة التي تبحث عنها غير موجودة أو تم نقلها</p>
          <Link to="/" className="btn btn-gold-shimmer" style={{textDecoration:'none', padding:'12px 40px', fontSize:'1.1rem'}}>
            العودة للرئيسية
          </Link>
        </div>
    </Layout>
  )
}

export default Pagenotfound
